// extracted by mini-css-extract-plugin
export default {"upcomingTournaments":"tournaments_upcomingTournaments__pbOr8"};